import { isFeatureEnabled } from '@lumapps/features';
import { isSuperAdmin } from '@lumapps/permissions';

import { FRONTIERS_ALPHA_FF } from '../constants';

export const canAccessDomainsManagement = isSuperAdmin;

export const isFrontiersAlphaEnabled = isFeatureEnabled(FRONTIERS_ALPHA_FF);
